export default __webpack_public_path__ + "static/media/IMG_5234.058269cd.JPG";